<template>
  <div class="public-information-block">
    <Banner :type="activeName" :total="total"/>

    <Breadcrumb />

    <div class="container-block">
      <el-row :gutter="60">
        <el-col :span="5">
          <ul class="menu-block">
            <li @click="activeName = 'submit_thesis'" :class="{active: activeName === 'submit_thesis'}">
              <!-- <img src="@/assets/imgs/icon54.png" class="grey"/>
              <img src="@/assets/imgs/icon55.png" class="blue"/> -->
              <span>论文润色/翻译需求</span>
            </li>
            <li @click="activeName = 'postgraduate_guidance'" :class="{active: activeName === 'postgraduate_guidance'}">
              <!-- <img src="@/assets/imgs/icon56.png" class="grey"/>
              <img src="@/assets/imgs/icon57.png" class="blue"/> -->
              <span>考研辅导需求</span>
            </li>
          </ul>
        </el-col>
        <el-col :span="19">
          <!-- type submit_thesis-论文润色/翻译需求  postgraduate_guidance-考研辅导需求-->
          <SubmitThesis v-if="activeName === 'submit_thesis'"/>
          <PostgraduateGuidance v-if="activeName === 'postgraduate_guidance'"/>
          
        </el-col>
      </el-row>

    </div>

  </div>
</template>

<script>
/**
 * @description 提交需求
 */
import * as api from '@/api/user'

// 面包屑
import Breadcrumb from '@/components/Breadcrumb'
// banner
import Banner from './banner'
// 考研辅导需求
import PostgraduateGuidance from './postgraduate_guidance'
// 论文润色/翻译需求
import SubmitThesis from './submit_thesis'

export default {
  name: 'publicInformation',
  components: {
    Breadcrumb,
    Banner,
    PostgraduateGuidance,
    SubmitThesis
  },
  data() {
    return {
      total: 0, // 订单总量
      activeName: 'submit_thesis',// type submit_thesis-论文润色/翻译需求  postgraduate_guidance-考研辅导需求
    }
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route() {
      this.activeName = this.$route.query.activeName ? this.$route.query.activeName : '6'
      // 页面路由变动后，滚动条滚动到顶部
      window.scrollTo(0, 0)
    },
  },
  created() {
    this.activeName = this.$route.query.activeName ? this.$route.query.activeName : 'submit_thesis'
    this.getOrderTotal() //获取订单总数
  },
  methods: {
    /**
     * @description 获取订单总数
     */
    getOrderTotal() {
      const _this = this
      const _param = {}
      api
        .orderTotal(_param)
        .then((res) => {
          const _data = res.data
          
          _this.total = _data.order_total || 0
        })
        .catch((err) => {
          console.log(err)
          // _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    /**
     * @description 左菜单点击
     */
    // menuClick(_active) {
    //   this.activeName = _active
    // }

  },
}
</script>
<style lang="scss" scoped>
.public-information-block {

  > .container-block > .el-row {
    margin-top: 20px;
  }

  .menu-block {
    background: #ffffff;
    margin: 0;
    padding: 25px;
    list-style-type: none;
    padding-bottom: 200px;

    li {
      margin: 0;
      padding: 0;
      list-style-type: none;
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #979797;
      height: 60px;
      border-bottom: 2px solid #edeef2;
      cursor: pointer;
      margin: 0 0 20px 0;

      img {
        height: 30px;
        margin: 0 10px 0 0;
      }

    }

    .grey {
      display: block;
    }

    .blue {
      display: none;
    }

    .active {
      color: $colorNormal;
      border-bottom: 2px solid $colorNormal;

      .grey {
        display: none;
      }

      .blue {
        display: block;
      }
    }

  }

  .more-service {
    width: 100%;
    // height: 400px;
    height: 350px;
    background: $colorNormal;
    color: #ffffff;
    text-align: center;
    overflow: hidden;
    margin: 120px 0 -80px 0;

    h2 {
      margin: 140px 0 30px 0;
      font-size: 36px;
      line-height: 1;
    }

    h3 {
      font-size: 22px;
      line-height: 1;
      margin: 0 0 25px 0;
    }

    .more-btn {
      width: 200px;
      height: 60px;
      border-radius: 3px;
      line-height: 60px;
      text-align: center;
      font-size: 30px;
      color: $colorNormal;
      background: #ffffff;
      margin: 0 auto;
    }

  }

}
</style>